import React from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { ScratchpadProvider } from "contexts/ScratchpadProvider";
import { Spinner } from "components/common";
import Scratchpad from "components/scratchpad/Scratchpad";
import CurrentUserContext from "contexts/CurrentUserContext";
import Navigation from "components/navigation/Navigation";
import ReportedErrorBoundary from "components/errors/ReportedErrorBoundary";
import RuntimeErrorBoundary from "components/errors/RuntimeErrorBoundary";
import NavigationTelemetry from "logic/telemetry/NavigationTelemetry";
import TelemetryDebugOverlay from "components/telemetry-debug/TelemetryDebugOverlay";
import HotkeysProvider from "contexts/HotkeysProvider";
import HotkeysModalContainer from "components/hotkeys/HotkeysModalContainer";
import PageContextProviders from "components/page/contexts/PageContextProviders";
import { singleton } from "logic/singleton";
import DefaultQueryParamProvider from "routing/DefaultQueryParamProvider";
import RightSidebarProvider from "contexts/RightSidebarProvider";
import RightSidebar from "components/layout/RightSidebar";
import RightSidebarContext from "contexts/RightSidebarContext";
const AppLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: auto;
`;
const MainContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
`;
const PageContent = styled.div`
  flex: 1;
  min-height: 0;
`;
const App = () => /* @__PURE__ */ React.createElement(DefaultQueryParamProvider, null, /* @__PURE__ */ React.createElement(CurrentUserContext.Consumer, null, (currentUser) => {
  if (!currentUser) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(RightSidebarProvider, null, /* @__PURE__ */ React.createElement(HotkeysProvider, null, /* @__PURE__ */ React.createElement(ScratchpadProvider, { loginName: currentUser.username }, /* @__PURE__ */ React.createElement(NavigationTelemetry, null), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AppLayout, null, /* @__PURE__ */ React.createElement(Navigation, null), /* @__PURE__ */ React.createElement(ReportedErrorBoundary, null, /* @__PURE__ */ React.createElement(ContentRow, null, /* @__PURE__ */ React.createElement(MainContentColumn, null, /* @__PURE__ */ React.createElement(Scratchpad, null), /* @__PURE__ */ React.createElement(RuntimeErrorBoundary, null, /* @__PURE__ */ React.createElement(PageContextProviders, null, /* @__PURE__ */ React.createElement(PageContent, null, /* @__PURE__ */ React.createElement(Outlet, null))))), /* @__PURE__ */ React.createElement(RightSidebarContext.Consumer, null, ({ isOpen }) => isOpen && /* @__PURE__ */ React.createElement(RightSidebar, null))))), /* @__PURE__ */ React.createElement(HotkeysModalContainer, null), /* @__PURE__ */ React.createElement(TelemetryDebugOverlay, null)))));
}));
export default singleton("components.App", () => App);
